var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud-wrapper"},[_c('crud',{key:_vm.reRender,attrs:{"filterBy":{filters: _vm.dataFilter},"form-component":_vm.AffiliateForm,"grid-columns":_vm.gridColumns,"gridSettings":{noNew: true},"grid-options":_vm.gridOptions,"obj":"backofficeAffiliate"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8bdb43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Affiliates.vue
// module id = null
// module chunks = 